import React, { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import BentoModules from "@/components/site/BentoModules";
import WorkingPages from "@/components/site/WorkingPages";
import AshaStory from "@/components/site/AshaStory";
import Gallery from "@/components/site/Gallery";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Notice from "@/components/site/Notice";
import Footer from "@/components/site/Footer";
import CheckoutModal from "@/components/site/CheckoutModal";
import ExitIntentBar from "@/components/site/ExitIntentBar";
import TopCountdownBar from "@/components/site/TopCountdownBar";
import AffiliateStrip from "@/components/site/AffiliateStrip";
import { useReferralCapture } from "@/lib/referral";

export default function Landing() {
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const lenisRef = useRef(null);
  useReferralCapture();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let raf;
    function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  // Pause Lenis when checkout modal is open (so page doesn't scroll behind)
  useEffect(() => {
    if (!lenisRef.current) return;
    if (checkoutOpen) {
      lenisRef.current.stop();
      document.body.style.overflow = "hidden";
    } else {
      lenisRef.current.start();
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [checkoutOpen]);

  const openCheckout = () => setCheckoutOpen(true);
  const closeCheckout = () => setCheckoutOpen(false);

  return (
    <main className="relative min-h-screen bg-[var(--cream)]" data-testid="landing-root">
      <Header onBuy={openCheckout} />
      <Hero onBuy={openCheckout} />
      <Marquee />
      <BentoModules onBuy={openCheckout} />
      <WorkingPages />
      <AshaStory />
      <Gallery />
      <Pricing onBuy={openCheckout} />
      <Testimonials />
      <Notice />
      <FAQ onBuy={openCheckout} />
      <AffiliateStrip />
      <Footer onBuy={openCheckout} />

      <CheckoutModal open={checkoutOpen} onClose={closeCheckout} />
      <ExitIntentBar onBuy={openCheckout} />
      <TopCountdownBar onBuy={openCheckout} />
    </main>
  );
}
